import React from "react";
import clsx from 'clsx';
import { Formik } from "formik";
import * as Yup from "yup";
import { TextField, withStyles, Button, Select, MenuItem, CircularProgress, IconButton, Input, InputAdornment, Typography, FormControl, InputLabel } from "@material-ui/core";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },

    submit: {
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px"
    },
    formControl: {
        width: "100%",
        marginBottom: theme.spacing(2)
    },
    buttons: {
        textAlign: "right"
    }
});

function UserForm(props) {
    const { classes, initialValues, handleSubmit, formSettings, loading, handleNext, translations, backValid, backendError, setBackendError, handleBack } = props;
    let submitAction = ''
    const [value, setValue] = React.useState(false);

    const handleClickShowPassword = () => {
        setValue(!value);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const key = 'user';

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={async (values, { setSubmitting }) => {
                    if (submitAction === 'finish') {
                        setSubmitting(true);
                        await handleSubmit(values);
                        setSubmitting(false);
                    }
                    if (submitAction === 'next') {
                        handleNext(values, key);
                    }
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue } = formikProps;

                    const onChangeEmail = (value) => {
                        if (backendError && backendError === "Email" && setBackendError) {
                            setBackendError(null)
                        }
                        setFieldValue("Email", value)
                    }

                    const inputProps = {
                        autoComplete: 'new-password',
                        form: {
                            autoComplete: 'off',
                        },
                      }

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                label={translations['name'] || 'Name'}
                                placeholder={translations['name'] || 'Name'}
                                name="FirstName"
                                fullWidth={true}
                                value={values.FirstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.FirstName && touched.FirstName)}
                                margin="normal"
                                inputProps={inputProps}
                            />
                            <TextField
                                label={translations['last_name'] || 'Last name'}
                                placeholder={translations['last_name'] || 'Last name'}
                                name="LastName"
                                fullWidth={true}
                                value={values.LastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LastName && touched.LastName)}
                                margin="normal"
                                inputProps={inputProps}
                            />

                            <TextField
                                label={translations['username'] || 'Username'}
                                placeholder={translations['username'] || 'Username'}
                                name="Username"
                                fullWidth={true}
                                value={values.Username}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Username && touched.Username)}
                                margin="normal"
                                inputProps={inputProps}
                            />
                            <TextField
                                label={translations['e_mail'] || 'E-Mail'}
                                placeholder={translations['e_mail'] || 'E-Mail'}
                                name="Email"
                                fullWidth={true}
                                value={values.Email}
                                onChange={backendError && setBackendError ? (event) => onChangeEmail(event.target.value) : handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Email && touched.Email) || (backendError && backendError === "Email")}
                                margin="normal"
                                type="email"
                                inputProps={inputProps}
                            />
                            <TextField
                                label={translations['phone_number'] || 'Phone number'}
                                placeholder={translations['phone_number'] || 'Phone number'}
                                name="PhoneNumber"
                                fullWidth={true}
                                value={values.PhoneNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.PhoneNumber && touched.PhoneNumber)}
                                margin="normal"
                                inputProps={inputProps}
                            />
                            <TextField
                                label={translations['user_position'] || 'Position'}
                                placeholder={translations['user_position'] || 'Position'}
                                name="Position"
                                fullWidth={true}
                                value={values.Position}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Position && touched.Position)}
                                margin="normal"
                                inputProps={inputProps}
                            />
                            <FormControl className={clsx(classes.margin, classes.formControl)}>
                                <InputLabel htmlFor="password">{translations['password'] || 'Password'}</InputLabel>
                                <Input
                                    type={value ? 'text' : 'password'}
                                    name="Password"
                                    value={values.Password}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    onBlur={handleBlur}
                                    error={!!(errors.Password && touched.Password)}
                                    inputProps={inputProps}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}>
                                                {value ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            <FormControl className={clsx(classes.margin, classes.formControl)}>
                                <InputLabel htmlFor="repeat_password">{translations['password_repeat'] || 'Password repeat'}</InputLabel>
                                <Input
                                    type={value ? 'text' : 'password'}
                                    value={values.RepeatPassword}
                                    onChange={handleChange}
                                    name="RepeatPassword"
                                    autoComplete="off"
                                    onBlur={handleBlur}
                                    error={!!(errors.RepeatPassword && touched.RepeatPassword)}
                                    inputProps={inputProps}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {value ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations['please_select_status'] || 'Please select status'}</InputLabel>
                                <Select label="Status" name="UserStatus" onChange={handleChange} value={values.UserStatus} className={classes.textField}>
                                    <MenuItem value={"active"}>Active</MenuItem>
                                    <MenuItem value={"inactive"}>Inactive</MenuItem>
                                </Select>
                            </FormControl>

                            <div className={classes.buttons} >
                                {formSettings.ButtonCancel ? (

                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        color={formSettings.ButtonCancel.Color}
                                        onClick={formSettings.ButtonCancel.handleCancel}
                                        disabled={loading}
                                    >
                                        {formSettings.ButtonCancel.Title}
                                    </Button>
                                ) : null
                                }

                                {formSettings.ButtonBack ? (

                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        color={formSettings.ButtonBack.Color}
                                        onClick={() => handleBack(values, key)}
                                        disabled={loading}
                                    >
                                        {formSettings.ButtonBack.Title}
                                    </Button>
                                ) : null
                                }          {formSettings.ButtonSkip ? (

                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        color={formSettings.ButtonSkip.Color}
                                        onClick={formSettings.ButtonSkip.handleSkip}
                                        disabled={loading}
                                    >
                                        {formSettings.ButtonSkip.Title}
                                    </Button>
                                ) : null
                                }
                                {formSettings.ButtonNext ? (
                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        color={formSettings.ButtonNext.Color}
                                        onClick={() => {
                                            submitAction = 'next';
                                            formikProps.submitForm();
                                        }}
                                        type="submit"
                                        disabled={backValid[key] ? !backValid[key] : loading || !(isValid && dirty) || isSubmitting}
                                    >
                                        {formSettings.ButtonNext.Title}
                                    </Button>
                                ) : null
                                }
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        onClick={() => {
                                            submitAction = 'finish';
                                            formikProps.submitForm();
                                        }}
                                        disabled={backValid[key] ? !backValid[key] : loading || !(isValid && dirty) || isSubmitting}
                                    >
                                        {loading || isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
}

export default withStyles(styles, { withTheme: true })(UserForm);
